(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.configuredAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.headerIsAlwaysSticky = this.configuredAlwaysSticky || this.desktopQuery.matches;
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      this.onBreakpointChange = () => {
        this.headerIsAlwaysSticky = this.configuredAlwaysSticky || this.desktopQuery.matches;
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        this.header.classList.toggle('shopify-section-header-sticky', this.headerIsAlwaysSticky);
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        this.setHeaderHeight();
      };
      this.desktopQuery.addEventListener('change', this.onBreakpointChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
      this.headerResizeObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ppv-announcement-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ppv-announcement-ticker')) {
    customElements.define('ppv-announcement-ticker', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ppv-ticker__track');
        this.source = this.querySelector('[data-source]');
        this.viewport = this.querySelector('.ppv-ticker__viewport');
        this.toggle = this.querySelector('.ppv-ticker__toggle');
        if (!this.source || !this.source.children.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.signature = '';
        this.toggle.setAttribute('aria-pressed', 'false');
        this.toggle.setAttribute('aria-label', this.dataset.pauseLabel);
        this.toggle.textContent = this.dataset.pauseText;
        this.hovered = false;
        this.focused = false;
        this.editorPaused = false;
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.toggle.setAttribute('aria-pressed', String(this.userPaused));
          this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
          this.toggle.textContent = this.userPaused ? this.dataset.playText : this.dataset.pauseText;
          this.updatePlayback();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'touch') return;
          this.hovered = true;
          this.updatePlayback();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.updatePlayback();
        }, options);
        this.addEventListener('focusin', (event) => {
          this.focused = this.viewport.contains(event.target);
          if (this.source.contains(event.target) && event.target.matches(':focus-visible') && this.animation) {
            this.animation.currentTime = 0;
            const offset = event.target.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left + this.viewport.scrollLeft;
            this.viewport.scrollLeft = Math.max(0, offset - 10);
          }
          this.updatePlayback();
        }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!this.isConnected) return;
            this.focused = this.viewport.contains(document.activeElement);
            if (!this.focused) this.viewport.scrollLeft = 0;
            this.updatePlayback();
          });
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          this.editorPaused = true;
          if (this.animation) this.animation.currentTime = 0;
          this.updatePlayback();
          event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.editorPaused = false;
          this.viewport.scrollLeft = 0;
          this.updatePlayback();
        }, options);
        this.reducedMotion.addEventListener('change', () => this.scheduleBuild(), options);
        this.observer = new ResizeObserver(() => this.scheduleBuild());
        this.observer.observe(this.viewport);
        this.observer.observe(this.source);
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.scheduleBuild();
        });
        this.scheduleBuild();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.animation?.cancel();
        this.animation = null;
        this.signature = '';
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      scheduleBuild() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.build();
        });
      }

      build() {
        const active = this.dataset.enabled === 'true' && !this.reducedMotion.matches;
        this.toggle.hidden = !active;
        if (!active) {
          this.animation?.cancel();
          this.animation = null;
          this.track.querySelectorAll('[data-clone]').forEach((node) => node.remove());
          this.removeAttribute('data-motion');
          this.viewport.scrollLeft = 0;
          this.signature = '';
          return;
        }
        this.setAttribute('data-motion', '');
        const distance = this.source.getBoundingClientRect().width;
        const viewportWidth = this.viewport.clientWidth;
        if (!distance || !viewportWidth) return;
        const signature = `${distance}:${viewportWidth}:${this.dataset.speed}`;
        if (signature === this.signature) return;
        this.signature = signature;
        this.animation?.cancel();
        this.track.querySelectorAll('[data-clone]').forEach((node) => node.remove());
        const count = Math.ceil(viewportWidth / distance) + 1;
        for (let i = 0; i < count; i += 1) {
          const clone = this.source.cloneNode(true);
          clone.removeAttribute('data-source');
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => node.removeAttribute('data-shopify-editor-block'));
          clone.querySelectorAll('a').forEach((node) => node.setAttribute('tabindex', '-1'));
          this.track.append(clone);
        }
        const speed = Math.max(15, Math.min(80, Number(this.dataset.speed) || 35));
        this.animation = this.track.animate(
          [{ transform: 'translateX(0)' }, { transform: `translateX(-${distance}px)` }],
          { duration: distance / speed * 1000, iterations: Infinity, easing: 'linear' }
        );
        this.updatePlayback();
      }

      updatePlayback() {
        if (!this.animation) return;
        if (this.userPaused || this.hovered || this.focused || this.editorPaused) this.animation.pause();
        else this.animation.play();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
